import i18n from 'i18next';
import LanguageDetector from 'i18next-browser-languagedetector';
import { initReactI18next } from 'react-i18next';

import enUS from '../locales/en-US/common.json';
import esES from '../locales/es-ES/common.json';
import jaJP from '../locales/ja-JP/common.json';
import koKR from '../locales/ko-KR/common.json';
import zhCN from '../locales/zh-CN/common.json';

i18n
  .use(LanguageDetector)
  .use(initReactI18next)
  .init({
    resources: {
      'zh-CN': {
        common: zhCN,
      },
      'en-US': {
        common: enUS,
      },
      'es-ES': {
        common: esES,
      },
      'ja-JP': {
        common: jaJP,
      },
      'ko-KR': {
        common: koKR,
      },
    },
    fallbackLng: 'en-US',
    supportedLngs: ['zh-CN', 'en-US', 'es-ES', 'ko-KR', 'ja-JP'],
    defaultNS: 'common',
    ns: ['common'],
    interpolation: {
      escapeValue: false,
    },
    detection: {
      order: ['localStorage', 'navigator'],
      caches: ['localStorage'],
    },
  });

export default i18n;
